// Import deps
import React, { useEffect, useState } from 'react'

// Import components
import { PuzzleTable } from './puzzle-list/puzzle-table'
import { useViewingWindow, getScreenClass, isScreenExtraSmall, getPadding } from './../shared/viewing-window'

// Import styles
import './../styles/main-screen.css'


//interfaces
interface PuzzleScoreData {
  title: string;
  score: number | undefined;
}

interface MainScreenUI {
  user: number;
  currentStreak: number;
  maxStreak: number;
  completed: number;
  puzzles: PuzzleScoreData[];
  handlePickPuzzle: (puzzleTitle: string) => void;
  handleRandomPuzzle: () => void;
  handleDaily: () => void;
}

export const MainScreen = (props: MainScreenUI) => {
    const [showPuzzleList, setShowPuzzleList] = useState(false)

    const closePuzzleList = () => {
      setShowPuzzleList(false);
    }

    const {width, height} = useViewingWindow();
    const {paddingLeft, paddingTop} = getPadding();
    let screenClass = getScreenClass();

    const translateForMobile = (screenClass == 'mobile')?  height / 6 : 0;

    const translateY = height / 2 - translateForMobile - paddingTop/2;
    const translateX = -paddingLeft/2;
    
    const styles = {
      transform: `translate(${translateX}px, ${translateY}px)`
    }
    const translateYTitle = translateY - 100;
    const stylesTitle = {
      transform: `translate(${translateX}px, ${translateYTitle}px)`,
      ...(isScreenExtraSmall() && { fontSize : '40px' })
    }

    return (
        <div className={screenClass}>
          <div className="main-screen">
              {(showPuzzleList)? (
                  <PuzzleTable 
                      user={props.user}
                      currentStreak={props.currentStreak}
                      maxStreak={props.maxStreak}
                      completed={props.completed}
                      puzzles={props.puzzles}
                      handlePickPuzzle={props.handlePickPuzzle} 
                      closePuzzleList={closePuzzleList}
                  />
            ) :
            (<>
            <div className='main-title title-font' style={stylesTitle}>
              <span className='fire'>Math</span><span className='water'>Lock</span>
            </div>
              <div className='options' style={styles}>
              <button
                  className="btn standard-btn btn-daily"
                  onClick={() => props.handleRandomPuzzle()}>
                  Random puzzle
              </button>
              <button
                  className="btn standard-btn btn-daily"
                  onClick={() => props.handleDaily()}>
                  Daily puzzle
              </button> 
              <button
                  className="btn standard-btn btn-stats"
                  onClick={() => setShowPuzzleList(true)}>
                  Show Stats
              </button> 
            </div>
            </>)
          }
          </div>
      </div>
      )
    }